import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { IntegratorContextProvider } from './context/IntegratorContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordWithToken from './pages/ResetPasswordWithToken';
import ChangePassword from './pages/ChangePassword';
import Machines from './pages/Machines';
import MachineDetail from './pages/MachineDetail';
import MachineTypes from './pages/MachineTypes';
import Customers from './pages/Customers';
import IndexingStatus from './pages/IndexingStatus';
import AdminUsers from './pages/AdminUsers';
import StatsPage from './pages/Stats';
import AiCostsPage from './pages/AiCosts';
import AssignmentsPage from './pages/Assignments';
import SettingsPage from './pages/Settings';
import TicketResolver from './pages/TicketResolver';
import MyTickets from './pages/MyTickets';
import GdprPage from './pages/Gdpr';
import ScanReport from './pages/ScanReport';
import CompanyAccount from './pages/CompanyAccount';
import Profile from './pages/Profile';
import Notes from './pages/Notes';
import Documentation from './pages/Documentation';
import Integrators from './pages/Integrators';
import Billing from './pages/Billing';
import TeamMembers from './pages/TeamMembers';
import TeamInvitations from './pages/TeamInvitations';
import Subscription from './pages/Subscription';
import AcceptInvite from './pages/AcceptInvite';
import { Terms, PrivacyPolicy } from './pages/Legal';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <IntegratorContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Rejestracja wyłączona — konta zakłada się wyłącznie przez zaproszenia mailowe. */}
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPasswordWithToken />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          {/* Publiczne — linkuje do nich formularz aktywacji zaproszenia (przed zalogowaniem). */}
          <Route path="/regulamin" element={<Terms />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/m/:qrSlug/report" element={<ScanReport />} />
          <Route path="/t/:ticketId" element={<TicketResolver />} />
          <Route element={<Layout />}>
            <Route path="/machines" element={<Machines />} />
            <Route path="/machines/:id" element={<MachineDetail />} />
            <Route path="/machine-types" element={<MachineTypes />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/company-account" element={<CompanyAccount />} />
            {/* Stary adres — przekierowanie po zmianie "Moje konto" → "Konto firmy". */}
            <Route path="/my-account" element={<Navigate to="/company-account" replace />} />
            <Route path="/my-tickets" element={<MyTickets />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/admin/integrators" element={<Integrators />} />
            <Route path="/admin/billing" element={<Billing />} />
            <Route path="/team" element={<Navigate to="/team/members" replace />} />
            <Route path="/team/members" element={<TeamMembers />} />
            <Route path="/team/invitations" element={<TeamInvitations />} />
            <Route path="/team/subscription" element={<Subscription />} />
            <Route path="/admin/indexing" element={<IndexingStatus />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/stats" element={<StatsPage />} />
            <Route path="/admin/ai-costs" element={<AiCostsPage />} />
            <Route path="/admin/assignments" element={<AssignmentsPage />} />
            <Route path="/admin/settings" element={<SettingsPage />} />
            <Route path="/admin/gdpr" element={<GdprPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/machines" replace />} />
        </Routes>
      </BrowserRouter>
      </IntegratorContextProvider>
    </AuthProvider>
  );
};

export default App;
